'use client';
import React from 'react';
import { DateRangePicker, Heading } from '@ui';
import { Section, Container } from '@layout';
import { withOptionalId } from '@lib/withOptionalId';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

type DateRangePickerDemoProps = {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
};

const DateRangePickerDemo = ({
  sectionID = 'date-range-picker',
  classes = '',
  containerId,
  containerClasses,
  isSpanish = false,
}: DateRangePickerDemoProps) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Date-Range Picker', 'Selector de rango de fechas')}</Heading>
        <p className='sub full'>
          {t(
            'Select start and end dates using the calendar or the quick presets. Click a day to set the start date, then click another day to set the end date (clicking an earlier day will swap start and end). Use the presets for common ranges and the Clear button to reset.',
            'Selecciona las fechas de inicio y fin usando el calendario o los presets rapidos. Haz clic en un dia para establecer la fecha de inicio; luego haz clic en otro dia para establecer la fecha de fin (si eliges un dia anterior se intercambian inicio y fin). Usa los presets para rangos comunes y el boton Limpiar para restablecer.'
          )}
        </p>
        <p id='drp-instructions' className='sub full sr-only'>
          {t(
            'Use the arrow keys to move between days, Page Up/Page Down to move between months, Home/End to jump to the start/end of the week, and Enter or Space to select the focused date.',
            'Usa las flechas para moverte entre dias, Av Pag/Re Pag para moverte entre meses, Inicio/Fin para ir al inicio/fin de la semana, y Enter o Espacio para seleccionar la fecha enfocada.'
          )}
        </p>
        <DateRangePicker />
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="card drp" data-daterange>
  <div class="drp-inputs">
    <input type="text" aria-label="Start" />
    <span class="separator"></span>
    <input type="text" aria-label="End" />
  </div>
  <div class="drp-presets">
    <button class="chip" type="button">Last 7 days</button>
  </div>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default DateRangePickerDemo;
